import lozad from 'lozad';

export default class LazyImages {
    constructor($lazy) {
        const observer = lozad($lazy, {
            load($el) {
                let $root = $el.parentElement;

                $el.src = $el.getAttribute('data-src');
                $el.classList.remove('vgtrk-lazy');
                $root.classList.remove('vgtrk-lazy-preloader');
            }
        });
        observer.observe();
    }
}
